<app-modal-header-common
  title="Create Assessment Template"
  [dialogRef]="dialogRef"
>
</app-modal-header-common>
<div class="plan-form">
  <p *ngIf="isTemplateFileRequired" class="uploaded-file">
    Template file - {{ this.data.uploadedFile.name }}
  </p>
  <form [formGroup]="templateForm">
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" required />
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Category</mat-label>
      <mat-select formControlName="category" required>
        <mat-option *ngFor="let option of categories" [value]="option.id">
          {{ option.display_name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Applicability</mat-label>
      <input matInput formControlName="applicability" />
    </mat-form-field>
    <mat-form-field
      class="w-100"
      appearance="outline"
      *ngIf="!isTemplateFileRequired"
    >
      <mat-label
        >Response Options<span class="required-asterisk">*</span></mat-label
      >
      <mat-chip-list #respChipList aria-label="Response selection">
        <mat-chip
          *ngFor="let res of selectedResponses; let i = index"
          [selectable]="true"
          [removable]="true"
          (removed)="removeResponse(i)"
        >
          {{ res }}
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>

        <input
          type="text"
          placeholder="Select response..."
          readonly
          [matChipInputFor]="respChipList"
          [matAutocomplete]="autoResp"
          #respTrigger="matAutocompleteTrigger"
          (click)="respTrigger.openPanel()"
        />
      </mat-chip-list>

      <mat-autocomplete
        #autoResp="matAutocomplete"
        (optionSelected)="addResponse($event.option.value)"
      >
        <mat-option
          *ngFor="let option of responseOptions"
          [value]="option.name"
        >
          {{ option.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="w-100" appearance="outline">
      <mat-label>Assessment scoring scale</mat-label>
      <input matInput formControlName="assessment_scoring_scale" />
    </mat-form-field>
    <app-tag
      [noIds]="true"
      [tagsIds]="assessmentTags"
      (childTags)="getChildTags($event)"
    ></app-tag>
    <div style="display: flex; justify-content: end" class="mt-3 gap-2">
      <button
        (click)="closeModal()"
        mat-button
        mat-dialog-close
        color="primary"
        class="mx-1"
      >
        Close
      </button>
      <button
        mat-raised-button
        color="primary"
        class="templ-btn"
        (click)="createAssessment()"
        [disabled]="templateForm.invalid"
      >
        Create
      </button>
    </div>
  </form>
</div>
